import { Link, Meta } from './Pagination';

export interface Category {
  id: string;
  name: string;
  name_translations?: Record<string, string>;
  type: string;
  label: string;
}

export interface Product {
  id: string;
  name: string;
  description: string;
  email_support: string;
  whatsapp_support: string;
  product_delivery: string;
  member_area_access: string;
  sales_page: string;
  status: string;
  category: Category;
}

export interface Offer {
  id: string;
  product_id: string;
  product: Product;
  name: string;
  price: number;
  is_affiliate_enabled: boolean;
  price_formatted: string;
  currency: string;
  sales_page: string | null;
  payment_type: string;
  recurring_interval: string;
}

export interface Upsell {
  id: string;
  accepted_page?: null | string;
  down_sell_button_color: string;
  down_sell_display_text: string;
  down_sell_display_text_color: string;
  funnel_type: FunnelType;
  name: string;
  offer: Offer;
  page: string;
  recused_page?: null | string;
  up_sell_button_color: string;
  up_sell_display_text: string;
  up_sell_display_text_color: string;
  [property: string]: any;
}

export interface UpsellsResponse {
  data: Upsell[];
  meta: Meta;
  links: Link;
}

export enum FunnelType {
  DownSell = 'down_sell',
  UpSell = 'up_sell',
}

export interface CreateUpsellDTO {
  productId: string;
  data: Omit<Upsell, 'id'>;
}

export interface UpdateUpsellDTO {
  productId: string;
  upsellId: string;
  data: Partial<Omit<Upsell, 'id'>>;
}

export interface DeleteUpsellDTO {
  productId: string;
  upsellId: string;
}
